import { createState, useState } from '@hookstate/core';

interface NameChangeReviewListState {
  detailDrawerOpen: boolean;
  id: string;
}

const initialState: NameChangeReviewListState = {
  detailDrawerOpen: false,
  id: '',
};

const nameChangeReviewListStateReviewListState = createState(initialState);

export function useNameChangeReviewListState() {
  return useState(nameChangeReviewListStateReviewListState);
}
